export default "__VITE_ASSET__a71f2faf__"